import { takeEvery } from 'redux-saga/effects';
import { fetchIndustiesAction } from '../actions';
import { fetchIndustiesSaga } from './fetchIndustiesSaga';

export function* industriesSagaWatcher() {
  yield takeEvery(fetchIndustiesAction.TYPE, fetchIndustiesSaga);
}
